// @ts-expect-error -- Suppresses TS and ESLint errors.
type _ = Types.Scalars;
import type * as Types from '../util-types.js';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type PublicSiteQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;

export type PublicSiteQuery = {
  publicSite?: {
    __typename: 'PublicSite';
    id: string;
    platformId: string;
    name: string;
    domain: string;
    logoUrl?: string | null;
    vertical?: Types.SiteVertical | null;
    enableSiteAssistant: boolean;
    siteAssistantFormId?: string | null;
    locations: Array<{
      __typename: 'Location';
      id: string;
      phoneNumber?: string | null;
      email?: string | null;
      addressLine1?: string | null;
      addressLine2?: string | null;
      addressCity?: string | null;
      addressState?: string | null;
      addressPostalCode?: string | null;
      googlePlaceId?: string | null;
    }>;
    insuranceAgencySettings?: {
      __typename: 'SiteInsuranceAgencySettings';
      id: string;
      agentFullName?: string | null;
      missionStatement?: string | null;
    } | null;
    socialLinks?: {
      __typename: 'SiteSocialLinks';
      id: string;
      facebookUrl?: string | null;
      linkedinUrl?: string | null;
      tiktokUrl?: string | null;
      instagramUrl?: string | null;
    } | null;
  } | null;
};

export const PublicSiteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublicSite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publicSite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'platformId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vertical' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressCity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressPostalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'insuranceAgencySettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agentFullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'missionStatement' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'socialLinks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebookUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tiktokUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'enableSiteAssistant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'siteAssistantFormId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublicSiteQuery, PublicSiteQueryVariables>;
